import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import FacetDataContext from '~/context/srp/FacetDataContext';

export default function useExpand(
  initialState: boolean
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const { triggerMenuDidExpand } = useContext(FacetDataContext);
  const [show, setShow] = useState(initialState);

  useEffectOnce(triggerMenuDidExpand, [triggerMenuDidExpand], show);

  return [show, setShow];
}
